import { render } from "./SelectTags.vue?vue&type=template&id=3dd2c86f"
import script from "./SelectTags.vue?vue&type=script&lang=js"
export * from "./SelectTags.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/www/app.rizome-bxl.be/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__